(function () {
  function closeModel(root) {
    if (!root) return;
    var toggle = root.querySelector('.up6-dit-model__toggle');
    if (toggle) toggle.checked = false;
    root.classList.remove('is-expanded');
    document.documentElement.style.overflow = '';
    var viewer = root.querySelector('.up6-dit-model__viewer');
    if (viewer && viewer.contentWindow) {
      viewer.contentWindow.postMessage({ type: 'up6-model-fullscreen', active: false }, '*');
    }
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-up6-model-fullscreen]');
    if (openButton) {
      var openRoot = openButton.closest('.shopify-section');
      if (!openRoot) return;
      openRoot.classList.add('is-expanded');
      document.documentElement.style.overflow = 'hidden';
      var openViewer = openRoot.querySelector('.up6-dit-model__viewer');
      if (openViewer && openViewer.contentWindow) {
        openViewer.contentWindow.postMessage({ type: 'up6-model-fullscreen', active: true }, '*');
      }
      return;
    }

    var closeButton = event.target.closest('[data-up6-model-close]');
    if (closeButton) closeModel(closeButton.closest('.shopify-section'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.up6-dit-model__toggle:checked').forEach(function (toggle) {
      closeModel(toggle.closest('.shopify-section'));
    });
  });
})();
